import { motion } from "framer-motion";
import { CORE_SKILLS, SOFTWARE } from "../data/projects";
import { SectionHeading } from "./Portfolio";

export const Skills = () => (
  <section id="skills" data-testid="skills-section" className="bg-[#f8f9fa] py-24">
    <div className="mx-auto max-w-6xl px-6">
      <SectionHeading eyebrow="Expertise" title="My Skills" />
      <div className="grid grid-cols-1 gap-14 lg:grid-cols-2">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <h3 className="mb-6 text-xl font-semibold text-[#212529]">Core Design Skills</h3>
          <ul className="grid grid-cols-1 gap-x-6 gap-y-3 sm:grid-cols-2">
            {CORE_SKILLS.map((s, i) => (
              <li key={s} data-testid={`core-skill-${i}`} className="flex items-start gap-3 text-sm text-[#6c757d]">
                <span className="mt-1.5 h-1.5 w-1.5 shrink-0 bg-accent" />
                {s}
              </li>
            ))}
          </ul>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
        >
          <h3 className="mb-6 text-xl font-semibold text-[#212529]">Software &amp; Tools</h3>
          <div className="flex flex-wrap gap-3">
            {SOFTWARE.map((s, i) => (
              <span
                key={s.name}
                data-testid={`software-chip-${i}`}
                className="flex cursor-default items-center gap-2.5 rounded-full border border-[#212529]/15 bg-white py-2 pl-2.5 pr-5 text-sm font-normal text-[#212529] transition-all duration-300 hover:border-accent hover:shadow-md"
              >
                <img src={s.icon} alt={`${s.name} logo`} loading="lazy" className="h-6 w-6" />
                {s.name}
              </span>
            ))}
          </div>
          <p className="mt-8 text-sm leading-relaxed text-[#6c757d]">
            Keen to keep exploring new design tools and emerging creative technology.
          </p>
        </motion.div>
      </div>
    </div>
  </section>
);
